import { PropsWithChildren } from "react";

import { Card } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

export default function TransactionCard({ children }: PropsWithChildren) {
  const tailwind = useTailwind();
  return (
    <Card style={tailwind("mt-4 rounded-xl")}>
      <Card.Content>{children}</Card.Content>
    </Card>
  );
}
